import {IntlKeyValuePair, IntlNamespaces} from "./types";

export const INTL_ACCOUNT_LOCKED: IntlKeyValuePair = {
    key: "accountLocked",
    defaultValue: "Account Locked",
    intlValue: "Account Locked",
    namespace: IntlNamespaces.ACCOUNT_LOCKED,
};

export const INTL_ACCOUNT_LOCKED_MESSAGE: IntlKeyValuePair = {
    key: "accountLockedMessage",
    defaultValue:
        "For your security, your account has been locked after too many unsuccessful login attempts.",
    intlValue:
        "For your security, your account has been locked after too many unsuccessful login attempts.",
    namespace: IntlNamespaces.ACCOUNT_LOCKED,
};

export const INTL_UNLOCK_INSTRUCTIONS: IntlKeyValuePair = {
    key: "unlockInstructions",
    defaultValue:
        "We have sent you an email to reset your password. After resetting your password, your account will immediately unlock.",
    intlValue:
        "We have sent you an email to reset your password. After resetting your password, your account will immediately unlock.",
    namespace: IntlNamespaces.ACCOUNT_LOCKED,
};

export const INTL_REQUEST_NEW_EMAIL: IntlKeyValuePair = {
    key: "requestNewEmail",
    defaultValue: "Didn't receive a password reset email? Request a new one ",
    intlValue: "Didn't receive a password reset email? Request a new one ",
    namespace: IntlNamespaces.ACCOUNT_LOCKED,
};

export const INTL_HERE: IntlKeyValuePair = {
    key: "here",
    defaultValue: "here.",
    intlValue: "here.",
    namespace: IntlNamespaces.ACCOUNT_LOCKED,
};
